import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const milestoneUseStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			flexGrow: 1,
		},
		menuButton: {
			margin: 0,
			padding: '0.5rem 0 0 .8rem',
			color: '#a22f00',
			borderTopLeftRadius: '30rem',
			borderBottomLeftRadius: 20,
		},
		text: { padding: '1rem 3.2rem', fontFamily: 'Poppins', fontSize: '14px', textAlign:'center' },
		ageText: { textAlign: 'center', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 'lighter' },
		nameText: { textAlign: 'center', fontFamily: 'Poppins', fontSize: '18px', padding: '1rem 0 0' },
		header: {
			fontFamily: 'Poppins',
			fontSize: '14px',
		},
		styledMenuItem: {
			padding: '1rem 3rem',
		},
		loading: {
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'column',
			alignItems: 'center',
			marginTop: '3rem',
		},
		logout: {
			display: 'flex',
			background: 'none',
			boxShadow: 'none',
			color: '#67AEB3',
			fontFamily: 'Poppins',
			fontSize: '14px',
		},
		listItems: {
			listStyleType: 'none',
			display:'flex important',
			flexDirection:'column',
			margin: 0,
			padding: 0,
			[theme.breakpoints.down('xs')]: {
				// background: '#F1F6FA',
				// borderRadius: '2rem',
				// padding: '2rem !important',
				// fontSize: '16px',
			},
		},
	}),
);
